// import React from "react";

// const TravelCompanies = () => {
//   const companies = [
//     "Seahawk Travels",
//     "Ambassador Tours & Travels",
//     "Euro Cabs",
//     "WTI Cabs",
//     "Move In Sync",
//     "Golden Ikon",
//     "Select Cabs",
//     "Premier Travels",
//     "ABP Travels",
//   ];

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>
//         The clients listed above are being served through the travel companies
//         mentioned below :
//       </h2>
//       <div style={styles.grid}>
//         {companies.map((company, index) => (
//           <div key={index} style={styles.card}>
//             <span style={styles.dot}>●</span> {company}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: "40px 20px",
//     backgroundColor: "#fff",
//     textAlign: "center",
//     fontFamily: "Arial, sans-serif",
//   },
//   heading: {
//     fontSize: "20px",
//     fontWeight: "600",
//     marginBottom: "30px",
//     color: "#222",
//   },
//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//     gap: "20px",
//   },
//   card: {
//     backgroundColor: "#FFD54F",
//     padding: "20px",
//     borderRadius: "12px",
//     fontSize: "16px",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//     cursor: "pointer",
//   },
//   dot: {
//     marginRight: "8px",
//     color: "#000",
//   },
// };

// // Hover effect using inline style injection
// styles.card[":hover"] = {
//   transform: "translateY(-5px)",
//   boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
// };

// export default TravelCompanies;




// import React from "react";
// import { motion } from "framer-motion";
// import travelImg from "./pmm.png"; // apni image import karo

// const TravelCompanies = () => {
//   const companies = [
//     "Seahawk Travels",
//     "Ambassador Tours & Travels",
//     "Euro Cabs",
//     "WTI Cabs",
//     "Move In Sync",
//     "Golden Ikon",
//     "Select Cabs",
//     "Premier Travels",
//     "ABP Travels",
//   ];

//   return (
//     <div style={styles.container}>
//       {/* Heading */}
//       {/* <p style={styles.heading}>
//        Trusted Travel Partners
//       </p> */}
// <h1 style={styles.heading}>
//           Trusted Travel <span style={{ color: "rgb(235, 195, 101)" }}>Partners</span>
//        </h1>
//        <div style={styles.underline}></div>
//       <div style={styles.wrapper}>
//         {/* Left Side - Image with description */}
//         <motion.div
//           initial={{ x: -100, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           transition={{ duration: 0.8 }}
//           style={styles.left}
//         >
//           <div style={styles.imageWrapper}>
//             <img src={travelImg} alt="Travel" style={styles.image} />
//             <div style={styles.overlay}>
//               {/* <h3 style={styles.overlayTitle}>Trusted Travel Partners</h3> */}
//               {/* <p style={styles.overlayText}>
//                 We collaborate with leading travel companies to ensure smooth
//                 and reliable journeys for all our clients.
//               </p> */}
//             </div>
//           </div>
//         </motion.div>

//         {/* Right Side - Companies grid */}
//         <motion.div
//           initial={{ x: 100, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           transition={{ duration: 0.8 }}
//           style={styles.right}
//         >
//           <div style={styles.grid}>
//             {companies.map((company, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{ scale: 1.05 }}
//                 style={styles.card}
//               >
//                 <span style={styles.dot}>●</span> {company}
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: "50px 20px",
//     fontFamily: "Arial, sans-serif",
//     textAlign: "center",
//   },
  
//   heading: {
//     fontSize: "40px",
//     fontWeight: "bold",
//     marginBottom: "40px",
//     color: "#222",
//   },
//    underline : {
//   width: "200px",
//   height: "2px",
//   backgroundColor: "#000",
//   margin: "10px auto",
//   marginTop:'-20px'
// },
//   wrapper: {
//     display: "flex",
//     gap: "40px",
//     alignItems: "center",
//     justifyContent: "center",
//     flexWrap: "wrap",
//     maxWidth: "1200px", // ✅ max width set
//     margin: "0 auto",
//   },
//   left: {
//     flex: "1",
//     minWidth: "280px",
//     maxWidth: "500px", // ✅ image ko control kiya
//   },
//   right: {
//     flex: "1",
//     minWidth: "280px",
//   },
//   imageWrapper: {
//     position: "relative",
//     overflow: "hidden",
//     borderRadius: "16px",
//     // boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
//   },
//   image: {
//     width: "100%",
//     height: "auto",
//     borderRadius: "16px",
//   },
//   overlay: {
//     position: "absolute",
//     bottom: "0",
//     left: "0",
//     right: "0",
//     // background: "rgba(0, 0, 0, 0.6)",
//     color: "#fff",
//     padding: "20px",
//     borderRadius: "0 0 16px 16px",
//     textAlign: "left",
//   },
//   overlayTitle: {
//     fontSize: "25px",
//     marginBottom: "6px",
//     color:'gold',
//     fontWeight: "bold",
//   },
// overlayText: {
//   fontSize: "25px",
//   lineHeight: "1.4",
//   fontWeight: "bold",
//   textShadow: "2px 2px 6px rgba(0,0,0,0.8)", // stronger shadow
//   color: "white", // text color
//   background: "rgba(0, 0, 0, 0.6)", // semi-transparent black background
//   padding: "8px 15px", // spacing around text
//   borderRadius: "8px", // rounded background
//   display: "inline-block", // keep background tight to text
// },


//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", // ✅ smaller boxes
//     gap: "15px",
//   },
//   card: {
//     backgroundColor: "#FFD54F",
//     padding: "14px",
//     borderRadius: "10px",
//     fontSize: "14px",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },
//   dot: {
//     marginRight: "6px",
//     color: "#000",
//     fontSize: "14px",
//   },
// };

// export default TravelCompanies;




import React from "react";
import { motion } from "framer-motion";
import travelImg from "./pmm.png"; // apni image import karo

const TravelCompanies = () => {
  const companies = [
    "Seahawk Travels",
    "Ambassador Tours & Travels",
    "Euro Cabs",
    "WTI Cabs",
    "Move In Sync",
    "Golden Ikon",
    "Select Cabs",
    "Premier Travels",
    "ABP Travels",
  ];

  return (
    <div style={styles.container}>
      {/* Heading */}
      <h1 style={styles.heading}>
        Trusted Travel{" "}
        <span style={{ color: "rgb(235, 195, 101)" }}>Partners</span>
      </h1>
      <div style={styles.underline}></div>

      <div style={styles.wrapper}>
        {/* Left Side - Image with animation */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={styles.left}
        >
          <div style={styles.imageWrapper}>
            <img src={travelImg} alt="Travel" style={styles.image} />
            <div style={styles.overlay}></div>
          </div>
        </motion.div>

        {/* Right Side - Companies grid */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={styles.right}
        >
          <div style={styles.grid}>
            {companies.map((company, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                style={styles.card}
              >
                <span style={styles.dot}>●</span> {company}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* ✅ Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            .wrapper {
              flex-direction: column;
              text-align: center;
            }
            .left, .right {
              max-width: 90% !important;
            }
          }

          @media (max-width: 768px) {
            h1 {
              font-size: 28px !important;
            }
            .grid {
              grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
              gap: 12px !important;
            }
            .card {
              font-size: 13px !important;
              padding: 10px !important;
            }
          }

          @media (max-width: 480px) {
            h1 {
              font-size: 22px !important;
            }
            .grid {
              grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)) !important;
            }
            .card {
              font-size: 12px !important;
              padding: 8px !important;
            }
          }

          @media (max-width: 360px) {
            h1 {
              font-size: 18px !important;
            }
            .grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  container: {
    padding: "50px 20px",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
  },
  heading: {
    fontSize: "40px",
    fontWeight: "bold",
    marginBottom: "40px",
    color: "#222",
  },
  underline: {
    width: "200px",
    height: "2px",
    backgroundColor: "#000",
    margin: "10px auto",
    marginTop: "-20px",
  },
  wrapper: {
    display: "flex",
    gap: "40px",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  left: {
    flex: "1",
    minWidth: "280px",
    maxWidth: "500px",
  },
  right: {
    flex: "1",
    minWidth: "280px",
  },
  imageWrapper: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "16px",
  },
  image: {
    width: "100%",
    height: "auto",
    borderRadius: "16px",
  },
  overlay: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    color: "#fff",
    padding: "20px",
    borderRadius: "0 0 16px 16px",
    textAlign: "left",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "15px",
  },
  card: {
    backgroundColor: "#FFD54F",
    padding: "14px",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  dot: {
    marginRight: "6px",
    color: "#000",
    fontSize: "14px",
  },
};

export default TravelCompanies;
